import CommonUiModel from "../common/commonUiModel";

const Country = new CommonUiModel({
    title: "Country",
    formTitle: 'SCM Countries',
    gridTitle: 'SCM Countries',
    permissions: { delete: false, add: false },
    columns: [
        { field: 'CountryName', label: 'Country Name', min: 3, max: 50, readOnly: true },
        { field: 'CountryCode2', label: 'Country Code', min: 1, max: 50, readOnly: true, width: 120 },
        { field: 'CountryCode3', label: 'Country Code 3', min: 1, max: 50, hide: true, readOnly: true },
        { field: 'RegionId', label: 'Region', width: 200, type: 'select', lookup: 'Region', dataIndex: "RegionName" },
        { field: 'SubRegion', label: 'Sub Region', hide: true, min: 3, max: 50, readOnly: true }
    ]
});

export default Country;